module.exports = __webpack_public_path__ + "img/gy7.dff55c80.png";